/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Botica API
 * API for the Botica professional network for Venezuelan pharmacists
 * OpenAPI spec version: v1
 */
import type {
  AdminLoginResponse,
  AuthResponse,
  LoginRequest,
  MfaEnrollRequest,
  MfaEnrollResponse,
  MfaLoginRequest,
  RefreshTokenRequest
} from '../boticaAPI.schemas';

import { axiosInstance } from '../../axiosInstance';



  export const getAdminAuth = () => {
const postApiAuthAdminLogin = (
    loginRequest: LoginRequest,
 ) => {
      return axiosInstance<AdminLoginResponse>(
      {url: `/api/auth/admin/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest
    },
      );
    }
  const postApiAuthAdminLoginMfa = (
    mfaLoginRequest: MfaLoginRequest,
 ) => {
      return axiosInstance<AuthResponse>(
      {url: `/api/auth/admin/login/mfa`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mfaLoginRequest
    },
      );
    }
  const postApiAuthAdminLoginMfaEnroll = (
    mfaEnrollRequest: MfaEnrollRequest,
 ) => {
      return axiosInstance<MfaEnrollResponse>(
      {url: `/api/auth/admin/login/mfa/enroll`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mfaEnrollRequest
    },
      );
    }
  const postApiAuthAdminRefresh = (
    refreshTokenRequest: RefreshTokenRequest,
 ) => {
      return axiosInstance<AuthResponse>(
      {url: `/api/auth/admin/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshTokenRequest
    },
      );
    }
  return {postApiAuthAdminLogin,postApiAuthAdminLoginMfa,postApiAuthAdminLoginMfaEnroll,postApiAuthAdminRefresh}};
export type PostApiAuthAdminLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['postApiAuthAdminLogin']>>>
export type PostApiAuthAdminLoginMfaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['postApiAuthAdminLoginMfa']>>>
export type PostApiAuthAdminLoginMfaEnrollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['postApiAuthAdminLoginMfaEnroll']>>>
export type PostApiAuthAdminRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminAuth>['postApiAuthAdminRefresh']>>>
